<template>
  <div>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>

    <!-- display: flex; justify-content: flex-end; -->

    <b-row
      class="align-top"
      style="width: 100%; display: flex; justify-content: flex-end"
    >
      <div
        class="dashboard-indicator-1"
        @click="selectCard('card1')"
        :class="{ 'selected-card': selectedCard === 'card1' }"
        style="
          text-align: center;
          background-color: #627180;
          border-radius: 10px;
          padding-left: 10px;
          padding-right: 10px;
        "
      >
        <a
          href=""
          @click.prevent="toggleStatusNameFilter('Viagens em Andamento')"
        >
          <p class="dashboard-indicator-title">
            {{ dashboard.tripsEmAndamento }}
          </p>
          <p class="dashboard-indicator-category">Viagens em Andamento</p>
        </a>
      </div>

      <!-- <div
        class="dashboard-indicator-1 status-pending"
        @click="selectCard('card2')"
        :class="{ 'selected-card': selectedCard === 'card2' }"
      >
        <a href="" @click.prevent="toggleStatusNameFilter('Aguardando Inicio')">
          <div class="dashboard-indicator-2">
            <p class="dashboard-indicator-title">
              {{ dashboard.tripsAguardandoInicio }}
            </p>
            <p class="dashboard-indicator-category">Aguardando Inicio</p>
          </div>
        </a>
      </div> -->

      <!-- <div
        class="dashboard-indicator-1 status-blue"
        @click="selectCard('card3')"
        :class="{ 'selected-card': selectedCard === 'card3' }"
      >
        <a href="" @click.prevent="toggleStatusNameFilter('Carregamento')">
          <div class="dashboard-indicator-2">
            <p class="dashboard-indicator-title">
              {{ dashboard.tripsCarregamento }}
            </p>
            <p class="dashboard-indicator-category">Carregamento</p>
          </div>
        </a>
      </div> -->

      <div
        class="dashboard-indicator-1 status-pending"
        @click="selectCard('card4')"
        :class="{ 'selected-card': selectedCard === 'card4' }"
      >
        <a href="" @click.prevent="toggleStatusNameFilter('Descarregamento')">
          <div class="dashboard-indicator-2">
            <p class="dashboard-indicator-title">
              {{ dashboard.tripsDescarregamento }}
            </p>
            <p class="dashboard-indicator-category">Descarregamento</p>
          </div>
        </a>
      </div>

      <div
        class="dashboard-indicator-1 status-iddle"
        @click="selectCard('card5')"
        :class="{ 'selected-card': selectedCard === 'card5' }"
      >
        <a href="" @click.prevent="toggleStatusNameFilter('Dentro do prazo')">
          <div class="dashboard-indicator-2">
            <p class="dashboard-indicator-title">
              {{ dashboard.tripsDentroDoPrazo }}
            </p>
            <p class="dashboard-indicator-category">Dentro do Prazo</p>
          </div>
        </a>
      </div>

      <div
        class="dashboard-indicator-1 status-ok"
        @click="selectCard('card6')"
        :class="{ 'selected-card': selectedCard === 'card6' }"
      >
        <a href="" @click.prevent="toggleStatusNameFilter('Adiantadas')">
          <div class="dashboard-indicator-2">
            <p class="dashboard-indicator-title">
              {{ dashboard.tripsAdiantadas }}
            </p>
            <p class="dashboard-indicator-category">Adiantadas</p>
          </div>
        </a>
      </div>
      <div
        class="dashboard-indicator-1 status-problem"
        @click="selectCard('card7')"
        :class="{ 'selected-card': selectedCard === 'card7' }"
      >
        <a href="" @click.prevent="toggleStatusNameFilter('Atrasadas')">
          <div class="dashboard-indicator-2">
            <p class="dashboard-indicator-title">
              {{ dashboard.tripsAtrasadas }}
            </p>
            <p class="dashboard-indicator-category">Atrasadas</p>
          </div>
        </a>
      </div>
    </b-row>

    <div v-if="isLoadingPage">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <b-row v-else>
      <b-button size="sm" @click="clearFilters()"> Limpar Filtros </b-button>

      <b-table
        ref="table"
        class="table-nowrap shLogStatusTrip"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        small
        show-empty
        :emptyFilteredText="$t('table.noRecord')"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </template>

        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.key"
              class="vertical-align"
            >
              <div v-if="field.type == 'date'">
                <b-form-input
                  class="dateIndividual"
                  type="date"
                  v-model="tableFilters[field.key]"
                />
              </div>

              <div v-else-if="field.key == 'deliveryStatus'">
                <single-select
                  :value.sync="tableFilters.deliveryStatus"
                  :value-property="'value'"
                  :options="statusOptions"
                />
              </div>
              <div v-else-if="field.key == 'statusName'">
                <single-select
                  :value.sync="tableFilters.statusName"
                  :value-property="'value'"
                  :options="tripsStages"
                />
              </div>
              <div v-else>
                <b-form-input v-model="tableFilters[field.key]" />
              </div>
            </b-th>
          </b-tr>
        </template>

        <template v-slot:cell()="cell">
          <!-- <div>
            {{ cell.index + 1 }}
          </div> -->

          <div v-if="cell.field.key == 'id'">
            <a
              href=" #"
              @click.prevent="
                $refs.fillingDetails.show(
                  cell.value,
                  cell.item.stageId,
                  cell.item.CanComment == 'True'
                )
              "
            >
              # <u>{{ cell.value }}</u>
            </a>
          </div>
          <div
            v-else-if="cell.field.key == 'deliveryStatus'"
            :class="getEtapaClassName(cell.item)"
          >
            {{ cell.value }}
          </div>
          <div v-else-if="cell.field.key == 'motorista'">
            <div class="td-limitado">
              {{ cell.value }}
            </div>
          </div>
          <div v-else-if="cell.field.key == 'conclusionPercentual'">
            <!-- <b-progress :value="cell.item.conclusionPercentual" :max="100" show-value height="36px"
                            variant="info" style="width: 125px; border-color: #a0a0a0; border-style: solid;">
                            <b-progress-bar :value="cell.item.conclusionPercentual"
                                :label="`${((cell.item.conclusionPercentual / 100) * 100).toFixed(2)}%`"></b-progress-bar>
                        </b-progress> -->
            <base-progress :value="cell.value" value-position="right" />
          </div>
          <div v-else-if="cell.field.key == 'responsavelAcompanhamento'">
            <div class="td-limitado">
              {{ cell.value }}
            </div>
          </div>
          <div v-else-if="cell.field.key == 'rotaNome'">
            <div class="td-limitado">
              {{ cell.value }}
            </div>
          </div>
          <div
            v-else-if="cell.field.key == 'statusName'"
            :class="getEtapaClassName(cell.item)"
          >
            {{ cell.value }}
          </div>
          <div v-else>
            {{ cell.value }}
          </div>
        </template>
      </b-table>
    </b-row>
    <workflow-occurreces-filled-modal ref="WorkflowOccurrecesFilledModal" />

    <!-- <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props> -->

    <filling-details-modal
      ref="fillingDetails"
      :processName="'Programação'"
      :permissions="permissions"
    ></filling-details-modal>
  </div>
</template>
<script>
import { BaseProgress } from "src/components";
import { text } from "d3";

export default {
  name: "ShlogTripStatusList",
  components: {
    BaseProgress,
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    FillingDetailsModal: () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/FillingDetailsModal.vue"
      ),
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    WorkflowOccurrecesFilledModal: () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/WorkflowOccurrecesFilledModal.vue"
      ),
    // TablePaginationProps: () =>
    //   import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      selectedCard: null,
      dashboard: {
        tripsAguardandoInicio: 0,
        tripsEmAndamento: 0,
        tripsDentroDoPrazo: 0,
        tripsAdiantadas: 0,
        tripsAtrasadas: 0,
        tripsCarregamento: 0,
        tripsDescarregamento: 0,
      },
      fields: [
        // {
        //   key: "contagem",
        //   label: "# "
        // },
        {
          key: "id",
          filterKey: "id",
          label: "Id",
          thStyle: "width: 100px;",
          stickyColumn: true,
          // variant: 'dark',
        },
        {
          key: "dataInicio",
          filterKey: "dataInicio",
          label: "Data de início",
          type: "date",
          formatter: (value, key, item) => {
            let date = new Date(value);
            let dateString = date.toLocaleDateString();
            let timeString = date.toLocaleTimeString();
            let dateTimeString = `${dateString} ${timeString}`;
            return dateTimeString;
          },
        },
        {
          key: "dataPrazo",
          filterKey: "dataPrazo",
          label: "Data de prazo",
          type: "date",
          thStyle: "width: 100px;",
          formatter: (value, key, item) => {
            let date = new Date(value);
            let dateString = date.toLocaleDateString();
            let timeString = date.toLocaleTimeString();
            let dateTimeString = `${dateString} ${timeString}`;
            return dateTimeString;
          },
        },
        {
          key: "dataPrevisaoFim",
          filterKey: "dataPrevisaoFim",
          label: "Previsão de fim",
          type: "date",
          thStyle: "width: 100px;",
          formatter: (value, key, item) => {
            let date = new Date(item.dataPrazo);
            let dateString = date.toLocaleDateString();
            let timeString = date.toLocaleTimeString();
            let dateTimeString = `${dateString} ${timeString}`;
            return dateTimeString;
          },
        },
        {
          key: "rotaNome",
          filterKey: "rotaNome",
          label: "Rota",
          thStyle: "width: 250px;",
        },
        {
          key: "motorista",
          filterKey: "motorista",
          label: "Motorista",
          thStyle: "width: 100px;",
        },
        {
          key: "placa",
          filterKey: "placa",
          label: "Placa",
          thStyle: "width: 100px;",
        },
        {
          key: "responsavelAcompanhamento",
          filterKey: "responsavelAcompanhamento",
          label: "Responsável Acompanhamento",
          thStyle: "text-align: center; width: 130px;",
        },
        {
          key: "conclusionPercentual",
          filterKey: "conclusionPercentual",
          label: "% Viagem",
          formatter: (value, key, item) => {
            return Math.floor(value);
          },
        },
        {
          key: "deliveryStatus",
          filterKey: "deliveryStatus",
          label: "Status",
          thStyle: "text-align: center; width: 230px;",
          formatter: (value, key, item) => {
            return this.getStatusName(item);
          },
        },
        {
          key: "statusName",
          filterKey: "statusName",
          label: "Etapa",
          thStyle: "text-align: center; width: 180px !important;",
        },
      ],
      tableFilters: {
        apenasChecklistGrisPendente: false,
        apenasDocumentacaoPendente: false,
        apenasViagensEmAndamento: true,
        apenasViagensNaoFinalizadas: false,
        id: null,
        dateCreate: "",
        dateChange: "",
        dataInicioBegin: null,
        dataInicioEnd: null,
        dataInicio: "",
        dataPrazo: "",
        dataPrevisaoFim: "",
        statusId: "",
        statusName: "",
        userName: "",
        allowComments: null,
        active: null,
        rotaNome: null,
        deliveryStatus: null,
        motorista: "",
        placa: "",
        carreta1: "",
        carreta2: "",
        emiteCte: null,
        cte: null,
        documentacao: "",
        precisaGris: null,
        checklistGrisPadraoId: null,
        checklistGrisPadraoStatus: "",
        responsavelAcompanhamento: "",
      },
      tripsStages: [
        { value: "Plano de Viagem", text: "Plano de Viagem" },
        { value: "Aguardando Aceite", text: "Aguardando Aceite" },
        { value: "GRIS", text: "GRIS" },
        { value: "Documentos", text: "Documentos" },
        { value: "Validação", text: "Validação/Liberação GR" },
        { value: "Inicio de Viagem", text: "Inicio de Viagem" },
        { value: "Em Viagem", text: "Em Viagem" },
        { value: "Fim de Viagem", text: "Fim de Viagem" },
      ],
      statusOptions: [
        { value: "Aguardando Inicio", text: "Aguardando Inicio" },
        { value: "Dentro do prazo", text: "Dentro do Prazo" },
        { value: "Carregamento", text: "Carregamento" },
        { value: "Descarregamento", text: "Descarregamento" },
        { value: "Adiantadas", text: "Adiantadas" },
        { value: "Atrasadas", text: "Atrasadas" },
        { value: "Viagens em Andamento", text: "Viagens em Andamento" },
      ],
      permissions: null,
      process: [],
      isBusy: false,
      isLoadingPage: false,
      tableRowCount: 0,
      tablePerPage: 10,
      tableCurrentPage: 1,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      timer: null,
    };
  },
  computed: {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.$refs.table.refresh();
    }, 240000);
    this.getPermissions();
  },
  methods: {
    async myProvider(ctx) {
      try {
        this.isBusy = true;

        const filters = this.createFilters();
        const url = this.createUrlList(filters);
        const response = await this.$apiWorkflow.get(url);
        const items = response.data.sort((a, b) => new Date(a.dataPrazo) - new Date(b.dataPrazo));

        this.resetDashboard();
        this.countDashboard(items);
        // this.percentual(filters);
        this.isBusy = false;
        this.tableRowCount = response.data.length;

        return items;
      } catch (error) {
        console.log("Error");
        console.log(error);
        console.log(error.response);
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.alert.error = error.message;
          this.$refs.danger.show();
          this.isBusy = false;
          this.tableRowCount = 0;
        }
        return [];
      }
    },
    createFilters() {
      const filters = {
        apenasChecklistGrisPendente:
          this.tableFilters.apenasChecklistGrisPendente,
        apenasDocumentacaoPendente:
          this.tableFilters.apenasDocumentacaoPendente,
        apenasViagensEmAndamento: this.tableFilters.apenasViagensEmAndamento,
        apenasViagensNaoFinalizadas:
          this.tableFilters.apenasViagensNaoFinalizadas,
        id: this.tableFilters.id,
        dateCreate: this.tableFilters.dateCreate,
        dateChange: this.tableFilters.dateChange,
        dataInicioBegin: this.tableFilters.dataInicioBegin,
        dataInicioEnd: this.tableFilters.dataInicioEnd,
        dataInicio: this.tableFilters.dataInicio,
        dataPrazo: this.tableFilters.dataPrazo,
        dataPrevisaoFim: this.tableFilters.dataPrevisaoFim,
        statusId: this.tableFilters.statusId,
        deliveryStatus: this.tableFilters.deliveryStatus,
        statusName: this.tableFilters.statusName,
        userName: this.tableFilters.userName,
        allowComments: this.tableFilters.allowComments,
        active: this.tableFilters.active,
        rotaNome: this.tableFilters.rotaNome,
        motorista: this.tableFilters.motorista,
        placa: this.tableFilters.placa,
        carreta1: this.tableFilters.carreta1,
        carreta2: this.tableFilters.carreta2,
        emiteCte: this.tableFilters.emiteCte,
        cte: this.tableFilters.cte,
        documentacao: this.tableFilters.documentacao,
        precisaGris: this.tableFilters.precisaGris,
        checklistGrisPadraoId: this.tableFilters.checklistGrisPadraoId,
        checklistGrisPadraoStatus: this.tableFilters.checklistGrisPadraoStatus,
        responsavelAcompanhamento: this.tableFilters.responsavelAcompanhamento,
      };
      return filters;
    },
    createUrlCount(filters) {
      var url = "/shlog/trip/status/count?";
      url = this.appendFiltersOnUrl(url, filters);
      return url;
    },
    createUrlList(filters) {
      var url = "/shlog/trip/status/list?";
      url = this.appendFiltersOnUrl(url, filters);
      return url;
    },
    getEtapaClassName(data) {
      const etapa = this.getStatusName(data);
      switch (etapa.toUpperCase()) {
        case "DENTRO DO PRAZO":
          return "table-cell status-cell status-iddle";
        case "ATRASADA":
          return "table-cell status-cell status-problem";
        case "ADIANTADA":
          return "table-cell status-cell status-ok";
        case "DESCARREGAMENTO":
          return "table-cell status-cell status-pending";
        case "CARREGAMENTO":
          return "table-cell status-cell status-blue";
        case "EM VIAGEM":
          if (new Date(data.dataPrazo) < new Date(data.dateChange)) {
            return "table-cell status-cell status-iddle";
          } else {
            return "table-cell status-cell status-problem";
          }
        default:
          return "table-cell status-cell status-pending";
      }
    },
    getPermissions() {
      const workflowProcessId = 13;
      this.$apiWorkflow
        .get(`/customFilter/GetPerimissions/${workflowProcessId}`)
        .then((response) => {
          this.permissions = response.data;
        });
    },
    getStatusName(trip) {
      switch (trip.statusName.toUpperCase()) {
        case "FIM DE VIAGEM":
          return this.isTripLate(trip) ? "Atrasada" : "Dentro do prazo";
        case "INICIO DE VIAGEM":
          return this.isTripLate(trip) ? "Atrasada" : "Dentro do prazo";
        case "EM VIAGEM":
          return this.isTripLate(trip) ? "Atrasada" : "Dentro do prazo";
        case "PLANO DE VIAGEM":
          return "Aguardando Inicio";
        case "AGUARDANDO ACEITE":
          return "Aguardando Inicio";
        case "DOCUMENTOS":
          return "Aguardando Inicio";
        case "VALIDAÇÃO/LIBERAÇÃO GR":
          return "Aguardando Inicio";
        case "GRIS":
          return "Aguardando Inicio";
        case "EM CARREGAMENTO":
          return "Carregamento";
        case "EM DESCARGA":
          return "Descarregamento";
        case "EM ESPERA":
          return "Descarregamento";
        default:
          return trip.statusName;
      }
    },
    isTripLate(trip) {
      switch (trip.statusName.toUpperCase()) {
        case "FIM DE VIAGEM":
          return new Date(trip.dataPrazo) < new Date();
        case "INICIO DE VIAGEM":
          return new Date(trip.dataPrazo) < new Date();
        case "EM VIAGEM":
          return new Date(trip.dataPrazo) < new Date();
        default:
          return false;
      }
    },
    countDashboard(items) {
      for (let trip of items) {
        if (trip.statusName) {
          switch (trip.statusName.toUpperCase()) {
            case "FIM DE VIAGEM":
              if (this.getStatusName(trip) == "Dentro do prazo") {
                this.dashboard.tripsDentroDoPrazo++;
              } else {
                this.dashboard.tripsAtrasadas++;
              }
              break;
            case "INICIO DE VIAGEM":
              if (this.getStatusName(trip) == "Dentro do prazo") {
                this.dashboard.tripsDentroDoPrazo++;
                this.dashboard.tripsEmAndamento++;
              } else {
                this.dashboard.tripsAtrasadas++;
                this.dashboard.tripsEmAndamento++;
              }
              break;
            case "EM VIAGEM":
              if (this.getStatusName(trip) == "Dentro do prazo") {
                this.dashboard.tripsDentroDoPrazo++;
                this.dashboard.tripsEmAndamento++;
              } else {
                this.dashboard.tripsAtrasadas++;
                this.dashboard.tripsEmAndamento++;
              }
              break;
            case "EM CARREGAMENTO":
              this.dashboard.tripsCarregamento++;
              break;
            case "EM DESCARGA":
              this.dashboard.tripsDescarregamento++;
              break;
            case "EM ESPERA":
              this.dashboard.tripsDescarregamento++;
              break;
            case "AGUARDANDO ACEITE":
              this.dashboard.tripsAguardandoInicio++;
              break;
            case "VALIDAÇÃO/LIBERAÇÃO GR":
              this.dashboard.tripsAguardandoInicio++;
              break;
            case "GRIS":
              if (trip.dataPrazo > trip.dateChange) {
                this.dashboard.tripsAguardandoInicio++;
              } else {
              }
              break;
            case "DOCUMENTOS":
              this.dashboard.tripsAguardandoInicio++;
              break;
            default:
              console.log("trip.statusName: " + trip.statusName);
              break;
          }
        }
      }
    },
    resetDashboard() {
      switch (this.tableFilters.deliveryStatus) {
        case "Aguardando Inicio":
          this.dashboard.tripsAguardandoInicio = 0;
          break;
        case "Dentro do prazo":
          this.dashboard.tripsDentroDoPrazo = 0;
          this.dashboard.tripsEmAndamento = 0;
          break;
        case "Adiantadas":
          this.dashboard.tripsAdiantadas = 0;
          this.dashboard.tripsDentroDoPrazo = 0;
          this.dashboard.tripsEmAndamento = 0;
          break;
        case "Atrasadas":
          this.dashboard.tripsAtrasadas = 0;
          this.dashboard.tripsEmAndamento = 0;
          break;
        case "Viagens em Andamento":
          this.dashboard.tripsDentroDoPrazo = 0;
          this.dashboard.tripsEmAndamento = 0;
          this.dashboard.tripsAtrasadas = 0;
          break;
        case "Carregamento":
          this.dashboard.tripsCarregamento = 0;
          break;
        case "Descarregamento":
          this.dashboard.tripsDescarregamento = 0;
          break;
        default:
          this.dashboard.tripsAtrasadas = 0;
          this.dashboard.tripsAdiantadas = 0;
          this.dashboard.tripsEmAndamento = 0;
          this.dashboard.tripsDentroDoPrazo = 0;
          this.dashboard.tripsAguardandoInicio = 0;
          this.dashboard.tripsCarregamento = 0;
          this.dashboard.tripsDescarregamento = 0;
          break;
      }
    },
    percentual(filters) {
      switch (filters.statusName) {
        case "Viagens em Andamento":
          for (let trip of items) {
            switch (trip.statusName.toUpperCase()) {
              case "INICIO DE VIAGEM":
                tripsList.push(trip);
                break;
            }
          }
          break;
        case "Aguardando Inicio":
          for (let trip of items) {
            switch (trip.statusName.toUpperCase()) {
              case "PLANO DE VIAGEM":
                tripsList.push(trip);
                break;
              case "AGUARDANDO ACEITE":
                tripsList.push(trip);
                break;
              case "DOCUMENTOS":
                tripsList.push(trip);
                break;
              case "VALIDAÇÃO":
                tripsList.push(trip);
                break;
            }
          }
          break;
        case "Dentro do Prazo":
          for (let trip of items) {
            switch (trip.statusName.toUpperCase()) {
              case "FIM DE VIAGEM":
                if (trip.conclusionPercentual == 0) {
                  trip.conclusionPercentual = 100;
                }

                if (this.getStatusName(trip) == "Dentro do prazo") {
                  tripsList.push(trip);
                }
                break;
              case "INICIO DE VIAGEM":
                if (this.getStatusName(trip) == "Dentro do prazo") {
                  tripsList.push(trip);
                }
                break;
            }
          }
          break;
        case "Adiantadas":
          break;
        case "Atrasadas":
          for (let trip of items) {
            switch (trip.statusName.toUpperCase()) {
              case "INICIO DE VIAGEM":
                if (this.getStatusName(trip) == "Atrasada") {
                  tripsList.push(trip);
                }
                break;
            }
          }
          break;
        default:
          for (let trip of items) {
            switch (trip.statusName.toUpperCase()) {
              case "FIM DE VIAGEM":
                if (trip.conclusionPercentual == 0) {
                  trip.conclusionPercentual = 100;
                }
                tripsList.push(trip);
                break;
              case "INICIO DE VIAGEM":
                tripsList.push(trip);
                break;
              case "PLANO DE VIAGEM":
                tripsList.push(trip);
                break;
              case "AGUARDANDO ACEITE":
                tripsList.push(trip);
                break;
              case "DOCUMENTOS":
                tripsList.push(trip);
                break;
              case "VALIDAÇÃO":
                tripsList.push(trip);
                break;
            }
          }
          break;
      }
    },
    clearFilters() {
      this.selectedCard = null;
      this.tableFilters = {
        apenasChecklistGrisPendente: false,
        apenasDocumentacaoPendente: false,
        apenasViagensEmAndamento: true,
        apenasViagensNaoFinalizadas: false,
        id: null,
        dateCreate: "",
        dateChange: "",
        dataInicioBegin: null,
        dataInicioEnd: null,
        dataInicio: "",
        dataPrazo: "",
        dataPrevisaoFim: "",
        statusId: "",
        statusName: "",
        userName: "",
        allowComments: null,
        active: null,
        rotaNome: null,
        deliveryStatus: null,
        motorista: "",
        placa: "",
        carreta1: "",
        carreta2: "",
        emiteCte: null,
        cte: null,
        documentacao: "",
        precisaGris: null,
        checklistGrisPadraoId: null,
        checklistGrisPadraoStatus: "",
        responsavelAcompanhamento: "",
      };
    },
    selectCard(cardId) {
      if (this.selectedCard === cardId) {
        this.selectedCard = null;
      } else {
        this.selectedCard = cardId;
      }
    },
    toggleStatusNameFilter(statusName) {
      if (this.tableFilters.deliveryStatus == statusName) {
        this.tableFilters.deliveryStatus = null;
      } else {
        this.tableFilters.deliveryStatus = statusName;
      }
    },
    appendFiltersOnUrl(url, filters) {
      if (filters.apenasChecklistGrisPendente) {
        url += `apenasChecklistGrisPendente=${filters.apenasChecklistGrisPendente}&`;
      }
      if (filters.apenasDocumentacaoPendente) {
        url += `apenasDocumentacaoPendente=${filters.apenasDocumentacaoPendente}&`;
      }
      if (filters.apenasViagensEmAndamento) {
        url += `apenasViagensEmAndamento=${filters.apenasViagensEmAndamento}&`;
      }
      if (filters.apenasViagensNaoFinalizadas) {
        url += `apenasViagensNaoFinalizadas=${filters.apenasViagensNaoFinalizadas}&`;
      }
      if (filters.dataInicioBegin != null && filters.dataInicioBegin != "") {
        url += `dataInicioBegin=${filters.dataInicioBegin}&`;
      }
      if (filters.dataInicioEnd != null && filters.dataInicioEnd != "") {
        url += `dataInicioEnd=${filters.dataInicioEnd}&`;
      }
      if (filters.id != null && filters.id != "") {
        url += `id=${filters.id}&`;
      }
      if (filters.dateCreate != null && filters.dateCreate != "") {
        url += `dateCreate=${filters.dateCreate}&`;
      }
      if (filters.dateChange != null && filters.dateChange != "") {
        url += `dateChange=${filters.dateChange}&`;
      }
      if (filters.deliveryStatus != null && filters.deliveryStatus != "") {
        url += `deliveryStatus=${filters.deliveryStatus}&`;
      }
      if (filters.statusName != null && filters.statusName != "") {
        url += `statusName=${filters.statusName}&`;
      }
      if (filters.userName != null && filters.userName != "") {
        url += `userName=${filters.userName}&`;
      }
      if (filters.allowComments != null && filters.allowComments != "") {
        url += `allowComments=${filters.allowComments}&`;
      }
      if (filters.active != null && filters.active != "") {
        url += `active=${filters.active}&`;
      }
      if (filters.dataInicio != null && filters.dataInicio != "") {
        url += `dataInicioEquals=${filters.dataInicio}&`;
      }
      if (filters.dataPrazo != null && filters.dataPrazo != "") {
        url += `dataPrazoEquals=${filters.dataPrazo}&`;
      }
      if (filters.dataPrevisaoFim != null && filters.dataPrevisaoFim != "") {
        url += `dataPrevisaoFim=${filters.dataPrevisaoFim}&`;
      }
      if (filters.rotaNome != null && filters.rotaNome != "") {
        url += `rotaNome=${filters.rotaNome}&`;
      }
      if (filters.motorista != null && filters.motorista != "") {
        url += `motorista=${filters.motorista}&`;
      }
      if (filters.placa != null && filters.placa != "") {
        url += `placa=${filters.placa}&`;
      }
      if (filters.placa != null && filters.placa != "") {
        url += `placa=${filters.placa}&`;
      }
      if (filters.carreta1 != null && filters.carreta1 != "") {
        url += `carreta1=${filters.carreta1}&`;
      }
      if (filters.carreta2 != null && filters.carreta2 != "") {
        url += `carreta2=${filters.carreta2}&`;
      }
      if (filters.emiteCte != null && filters.emiteCte != "") {
        url += `emiteCte=${filters.emiteCte}&`;
      }
      if (filters.cte != null && filters.cte != "") {
        url += `cte=${filters.cte}&`;
      }
      if (filters.documentacao != null && filters.documentacao != "") {
        url += `documentacao=${filters.documentacao}&`;
      }
      if (filters.precisaGris != null && filters.precisaGris != "") {
        url += `precisaGris=${filters.precisaGris}&`;
      }
      if (
        filters.checklistGrisPadraoId != null &&
        filters.checklistGrisPadraoId != ""
      ) {
        url += `checklistGrisPadraoId=${filters.checklistGrisPadraoId}&`;
      }
      if (
        filters.responsavelAcompanhamento != null &&
        filters.responsavelAcompanhamento != ""
      ) {
        url += `responsavelAcompanhamento=${filters.responsavelAcompanhamento}&`;
      }
      return url.substring(0, url.length - 1);
    },
  },
};
</script>

<style scoped>
.icon_style {
  color: #ec5353;
}

.dashboard-indicator {
  background: #627180;
  border-radius: 0.2857rem;
  height: 140px;
  min-width: 100px;
  max-width: 100px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: 0px !important;
  margin-right: 5px !important;
  text-align: center;
}

.dashboard-indicator-1 {
  width: 135px;
  padding: 20px 10px 15px 10px;
  margin-inline: 3px;
  border-radius: 10px;
}

.selected-card {
  border: 2px solid white;
}

.dashboard-indicator-2 {
  border-radius: 0.2857rem;
  text-align: center;
  /* height: 145px; */
}

.dashboard-indicator-title {
  /* color: black; */
  font-size: 45px;
}

.dashboard-indicator-category {
  font-size: 12px;
}

.table-cell {
  padding-top: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
  padding-left: 7px;
  margin-top: -12px;
  margin-bottom: -12px;
  margin-right: -10px;
  margin-left: 1px;
}

.status-cell {
  text-align: center;
}

.status-ok {
  background-color: #45a26e;
}

.status-problem {
  background-color: #ec5353;
  color: black;
}

.status-purple {
  background-color: purple;
}

.status-blue {
  background-color: rgb(44, 44, 252);
  color: white;
}

.status-moss-green {
  background-color: rgb(116, 179, 14);
  color: black;
}

.status-iddle {
  background-color: #a0a0a0;
  color: black;
}

.status-pending {
  background-color: #df9101;
  color: black;
  cursor: pointer;
}

.status-not-found {
  background-color: #000000;
  color: black;
}

.status-teste {
  text-align: center;
  background-color: #627180;
}

@keyframes transicao-alerta {
  from {
    background-color: #ee6b6e;
  }

  to {
    background-color: #d1001f;
  }
}

.alert-checklist-gris {
  animation: transicao-alerta 1s linear infinite;
  /* background-color: red; */
}

.alert-checklist-gris-title {
  text-align: center;
  color: white;
}
</style>
